import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { HttpService } from '@shared/providers/http.service';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService extends HttpService {
  constructor(httpClient: HttpClient, store: Store) {
    super(environment.endpoints.resetPassword, httpClient, store);
  }

  public forget(body) {
    return this.postAsync(body, '/forget');
  }

  public changePassword(body) {
    return this.postAsync(body, '/change_password');
  }

  public show(token) {
    return this.get(`/${token}`);
  }
}
